import { Component, Vue } from 'vue-property-decorator'
import {
	faBars,
	faChevronRight,
	faRotateRight,
	faPowerOff,
	faXmark,
	faHome,
	faCalculator,
	faTable,
	faUsers,
	faEnvelope,
	faHourglassEnd,
	faUmbrellaBeach,
	faRectangleList,
	faCog,
	faFilm,
	faUserGroup,
	faFolderOpen,
	faTimeline,
	faScaleBalanced,
	faQrcode,
	faCoins,
	faFileCircleCheck,
} from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import store from '@/store/store.js'
import api from '@/helpers/fetch'
import Link from '@/components/Link/index.vue'

library.add(
	faBars,
	faChevronRight,
	faRotateRight,
	faPowerOff,
	faXmark,
	faHome,
	faCalculator,
	faTable,
	faUsers,
	faEnvelope,
	faHourglassEnd,
	faUmbrellaBeach,

	faTimeline,

	faRectangleList,
	faCog,
	faFilm,
	faUserGroup,
	faFolderOpen,
	faScaleBalanced,
	faQrcode,
	faCoins,
	faFileCircleCheck,
)

@Component({
	components: { Link },
})
export default class LHeader extends Vue {
	menu: any[] = []
	async mounted() {
		const res = await api.get('/api/my-account/sidebar')
		const ascOrdering = function (a, b) {
			if (a.order < b.order) {
				return -1
			}
			if (a.order > b.order) {
				return 1
			}
			return 0
		}

		res.data.sort(ascOrdering)

		const menu = [
			...res.data.map((item) => {
				item.hoverOpen = false
				if (item.children) item.children.sort(ascOrdering)
				item.children.forEach((child) => {
					child.children.sort(ascOrdering)
				})

				return item
			}),
		]

		this.menu = menu
	}

	get user() {
		return store.user
	}

	get isDev() {
		const url = process.env.VUE_APP_URL || 'uat.portal'
		return url.indexOf('uat') > -1
	}

	get nameInitial() {
		return this.user.name.charAt(0)
	}

	get isCollaborator() {
		return store.user.isCollaborator
	}

	clearCache() {
		if (
			'serviceWorker' in navigator &&
			navigator.serviceWorker.controller !== null
		) {
			navigator.serviceWorker.controller.postMessage({
				action: 'clear-cache',
			})

			this.$bvToast.toast('Cache limpo! Recarregando a página...', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center',
			})

			setTimeout(() => {
				window.location.reload()
			}, 3000)
		}
	}

	async logout() {
		const res = await api.post('/api/logout', '')

		if (res.ok) this.$router.push('/login')
	}

	beforeMount() {
		// @ts-ignore
		const user = JSON.parse(localStorage.getItem('user'))
		Object.assign(store.user, user)
	}

	isUat() {
		return window.location.hostname.includes('uat.')
	}
}
